import { render, staticRenderFns } from "./index.vue?vue&type=template&id=706b2df5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=706b2df5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b2df5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706b2df5')) {
      api.createRecord('706b2df5', component.options)
    } else {
      api.reload('706b2df5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=706b2df5&scoped=true", function () {
      api.rerender('706b2df5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/GoodsListField/index.vue"
export default component.exports